import { render, staticRenderFns } from "./WhatIsMyEtherWallet.vue?vue&type=template&id=4c22d4b0&scoped=true&"
import script from "./WhatIsMyEtherWallet.vue?vue&type=script&lang=js&"
export * from "./WhatIsMyEtherWallet.vue?vue&type=script&lang=js&"
import style0 from "./WhatIsMyEtherWallet.vue?vue&type=style&index=0&id=4c22d4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c22d4b0",
  null
  
)

export default component.exports